import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';


const Header: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isHome, setIsHome] = useState(false);
  const { language, setLanguage } = useLanguage();
  const { t, i18n } = useTranslation();
  const { isAuthenticated, currentUser } = useAuth();
  
  useEffect(() => {
    setIsHome(location.pathname === '/');
  }, [location]);

  const goBack = () => {
    navigate(-1);
  };

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLanguage = event.target.value as 'en' | 'tr';
    setLanguage(newLanguage);
    i18n.changeLanguage(newLanguage);
  };

  // Force re-render when authentication state changes
  useEffect(() => {
    if (!isAuthenticated && location.pathname === '/profile') {
      navigate('/');
    }
  }, [isAuthenticated, location.pathname, navigate]);

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" className="logo-container">
            <img src="/logo.png" alt="Whomii Web Logo" className="header-logo" />
            <h1>Whomii</h1>
          </Link>
        </div>
        <div className="header-right">
          <div className="language-selector">
            <select 
              value={language} 
              onChange={handleLanguageChange} 
              className="language-dropdown" 
              aria-label="Select language"
            >
              <option value="en">EN</option>
              <option value="tr">TR</option>
            </select>
          </div>
          <ThemeToggle />
          {isAuthenticated && (
            <>
              <Link to="/modules" className="nav-button modules-button">
                {t('modules')}
              </Link>
              <Link to="/profile" className="profile-link" title={t('profile') || 'Profile'}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header; 